import { apiRequest } from "./api";

/**
 * Blog Service
 * Handles all API calls for the Admin Blog Editor.
 *
 * Base route: POST /admin/blog/posts
 * Auth: Bearer token (read from localStorage by apiRequest)
 */

/**
 * Create a new blog post.
 * Sends all editor form fields to POST /admin/blog/posts
 *
 * @param {Object} payload - Blog form data
 * @param {string} payload.title
 * @param {string} payload.body          - Rich text content
 * @param {string|null} payload.cover_image_url
 * @param {string} payload.category
 * @param {string[]} payload.tags
 * @param {"published"|"unpublished"} payload.status
 * @param {string|null} payload.slug     - Custom slug (optional, auto-generated if omitted)
 * @param {string|null} payload.author_name
 * @param {string|null} payload.meta_title
 * @param {string|null} payload.meta_description
 * @returns {Promise<Object>} - Created blog post data
 */
export async function createBlogPost(payload) {
  const response = await apiRequest("/admin/blog/posts", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  // apiRequest returns the full envelope — backend wraps data in { success, data, message }
  return response.data ?? response;
}

